import React from "react";
import { APIProvider, Map, AdvancedMarker, Pin } from "@vis.gl/react-google-maps";

function MainMap(props) {
    return (
        <APIProvider apiKey={props.apiKey}>
            <div style={{ height: "400px", width: "100%" }}>
                <Map
                    defaultZoom={props.mapData.zoom}
                    defaultCenter={{ lat: props.mapData.mapLat, lng: props.mapData.mapLng }}
                    mapId={props.mapID}
                    // onCameraChanged={(ev: MapCameraChangedEvent) => console.log("camera changed:", ev.detail.center, "zoom", ev.detail.zoom)}
                >
                    <AdvancedMarker position={{ lat: props.mapData.pinLat, lng: props.mapData.pinLng }}>
                        <Pin background={"#FBC04"} glyphColor={"#FFFFFF"} borderColor={"#0000FF"} />
                    </AdvancedMarker>
                </Map>
            </div>
        </APIProvider>
    );
}

export default MainMap;
